export default __webpack_public_path__ + "logo.54558bb76884f98e2dfcb65b482da355.png";